var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShekel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3b3c3d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24 5a19 19 0 1 0 19 19 19 19 0 0 0 -19-19zm-5 25a1 1 0 0 1 -2 0v-12a1 1 0 0 1 1-1h4a5 5 0 0 1 5 5v4a1 1 0 0 1 -2 0v-4a3 3 0 0 0 -3-3h-3zm12 0a1 1 0 0 1 -1 1h-4a5 5 0 0 1 -5-5v-4a1 1 0 0 1 2 0v4a3 3 0 0 0 3 3h3v-11a1 1 0 0 1 2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 48a24 24 0 1 1 24-24 24 24 0 0 1 -24 24zm0-46a22 22 0 1 0 22 22 22 22 0 0 0 -22-22z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShekel);
export default __webpack_public_path__ + "static/media/shekel.cbd3fd9fa9430bc555ac9127c91a0933.svg";
export { ForwardRef as ReactComponent };